import { CheckCheck, CircleHelp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { sendErrorText } from '../inboxModel';

export function MessageSendStatus({
  status,
  reviewRequired,
  error = null,
}: {
  status: string;
  reviewRequired?: boolean;
  /** Grund des Versandzyklus; scheitert der Versand, steht er an der Nachricht. */
  error?: string | null;
}) {
  const { t } = useTranslation();
  if (status === 'OutcomeUnknown') {
    return (
      <span
        className="text-ink-soft flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1"
        role="status"
      >
        <span className="inline-flex items-center gap-1">
          <CircleHelp size={12} aria-hidden />
          {t('messaging.sendUnknown')}
        </span>
        <span>{t(reviewRequired ? 'messaging.reviewRequired' : 'messaging.reviewing')}</span>
      </span>
    );
  }
  if (status === 'Sent') {
    return (
      <span className="text-sage inline-flex items-center gap-1">
        <CheckCheck size={12} aria-hidden />
        {t('messaging.sent')}
      </span>
    );
  }
  if (status === 'Pending') return <span>{t('messaging.sending')}</span>;
  if (status === 'Failed') {
    return (
      <span className="text-sealwax" role="status">
        {t('messaging.failed')}
        {error ? ` · ${sendErrorText(error)}` : ''}
      </span>
    );
  }
  return null;
}
